/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DeletePreviewViewModel } from "../types/DeletePreviewViewModel.ts";
import { eClassRoomDisciplinesStatusSchema } from "./eClassRoomDisciplinesStatusSchema.ts";

export const deletePreviewViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  disciplineName: z.string().nullish(),
  classStudentName: z.string().nullish(),
  dateStart: z.optional(z.string().datetime()),
  dateFinish: z.optional(z.string().datetime()),
  status: z.optional(
    z
      .lazy(() => eClassRoomDisciplinesStatusSchema)
      .describe("1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | "),
  ),
  recurrenceClassroomDisciplineId: z.number().int().nullish(),
  classStudentLinkCount: z.optional(z.number().int()),
  langCount: z.optional(z.number().int()),
  linkCount: z.optional(z.number().int()),
  prizeCount: z.optional(z.number().int()),
  attachmentCount: z.optional(z.number().int()),
  folderCount: z.optional(z.number().int()),
  classroomUserCount: z.optional(z.number().int()),
  groupAssociationCount: z.optional(z.number().int()),
  chatCount: z.optional(z.number().int()),
  surveyCount: z.optional(z.number().int()),
  examPublishCount: z.optional(z.number().int()),
  channelCount: z.optional(z.number().int()),
}) as unknown as ToZod<DeletePreviewViewModel>;
